import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import { Modal, Button, Form, Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Select from 'react-select'
import { clearCSVAuth } from '../../../redux/actions/authorization'
import { clearCSVClaims } from '../../../redux/actions/claims'
import './index.css'

interface Props {
  disableButton: boolean;
  organizationOptions: any;
  selectedOrganization: any;
  show: boolean;
  onClose: () => void;
  onChangeOrganization: (selected: any) => void;
  onClickSelect: () => void;
}

const SwitchOrganizationModal: FC<Props> = ({ disableButton, organizationOptions, selectedOrganization, show, onClose, onChangeOrganization, onClickSelect }: Props) => {
  const dispatch = useDispatch()

  const handleSelect = () => {
    onClickSelect()
    dispatch(clearCSVAuth('ORG'))
    dispatch(clearCSVClaims('ORG'))
  }

  return (
    <Modal size="lg" show={show} onHide={onClose}>
      <Modal.Header closeButton id="switch-organization-header">
        <FontAwesomeIcon icon={['fas', 'user-circle']} size="lg" className="switch-organization-header-icon" />
        <Modal.Title id="switch-organization-header-title">Switch Organization</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div className="switch-organization-body">
            <Form.Group  as={Col} lg={12} md={12} sm={12} xs={12}>
              <Form.Label>Organization</Form.Label>
              <Select
                placeholder="Choose an Organization"
                options={organizationOptions}
                value={selectedOrganization}
                isClearable
                onChange={onChangeOrganization}
              />
            </Form.Group>
          </div>
          <div className="switch-organization-btn-grp">
            <Button variant="secondary" id="switch-organization-cancel-btn" onClick={onClose}>
							Cancel
            </Button>
            <Button id="switch-organization-add-btn" disabled={disableButton} onClick={handleSelect}>
							Select Organization
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default SwitchOrganizationModal